var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacOsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3203,
    cy: 28.3203,
    r: 28.3203,
    transform: "matrix(1 0 0 -1 0.679688 57.3203)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0165 46.4324H40.2963L29.0513 30.181H28.9486L17.7292 46.4324H15.9834L28.1014 28.9487L16.0347 11.5676H17.7549L28.9229 27.7677H29.0256L40.1936 11.5676H41.9394L29.8728 28.9487L42.0165 46.4324Z",
    fill: "url(#paint0_linear_228_2390)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_2390",
    x1: 15.9834,
    y1: 46.4324,
    x2: 15.9834,
    y2: 11.5676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F44E28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOsx);
export default __webpack_public_path__ + "static/media/MacOSX.42cef3ee235c3673588bbc7dfb7e4ccc.svg";
export { ForwardRef as ReactComponent };